<app-help-page mainVideo="export-destinations"
               [tutorials]="['export-destinations']"
               [videos]="['export-destinations', 'exports']"></app-help-page>
